﻿import DotNetObject = DotNet.DotNetObject;
import { UAParser } from "ua-parser-js";
import { selectPortAsync as selectPort, connectAsync, writeAsync, closeAsync, bufferChunks } from "./webserial/WebSerialWrapper";

let onConnectionStateHasChanged: (newState: boolean) => void;
let startSendingAsync: () => Promise<void>;
let sendChunkAsync: (bytes: Uint8Array) => Promise<void>;
let finishSendingAsync: () => Promise<void>;

function checkBrowserIsSupported() : Boolean {
  const uaParser = new UAParser();
  const browser = uaParser.getBrowser().name;

  const browserIsSupported = browser === "Edge" || browser === "Chrome";

  return browserIsSupported;
}

const selectPortAsync = async (vendorId?: number, productId?: number) => {
  return await selectPort(vendorId, productId);
};

const connectToWebSerialAsync = async (bufferTimeMs: number, vendorId?: number, productId?: number) => {
  const onMessageReceived = async (bytes: Uint8Array) => {
    console.log("received bytes", bytes);

    await startSendingAsync();

    const chunkSize = 16 * 1024;
    for (let i = 0; i < bytes.length; i += chunkSize) {
      const chunk = bytes.slice(i, i + chunkSize);

      await sendChunkAsync(chunk);
    }

    await finishSendingAsync();
  }

  await connectAsync(bufferChunks(onMessageReceived, bufferTimeMs), onConnectionStateHasChanged);
};

const disconnectWebSerial = async () => {
  await closeAsync(onConnectionStateHasChanged);
}

const setOnConnectionStateHasChanged = (dotnetObj: DotNetObject, methodName: string) => {
  onConnectionStateHasChanged = async (newState: boolean) => {
    await dotnetObj.invokeMethodAsync(methodName, newState);
  };
}

const setStartSending = (dotnetObj: DotNetObject, methodName: string) => {
  startSendingAsync = async () => {
    await dotnetObj.invokeMethodAsync(methodName);
  };
}

const setSendChunk = (dotnetObj: DotNetObject, methodName: string) => {
  sendChunkAsync = async (bytes: Uint8Array) => {
    await dotnetObj.invokeMethodAsync(methodName, bytes);
  };
}

const setFinishSending = (dotnetObj: DotNetObject, methodName: string) => {
  finishSendingAsync = async () => {
    await dotnetObj.invokeMethodAsync(methodName);
  };
}

const resetCallbacks = () => {
  onConnectionStateHasChanged = null;
  startSendingAsync = null;
  sendChunkAsync = null;
  finishSendingAsync = null;
}

const advScope = window["adv"] = {};
const webSerialScope = advScope["WebSerial"] = {};

webSerialScope["IsBrowserSupported"] = checkBrowserIsSupported;

webSerialScope["SelectPort"] = selectPortAsync;

webSerialScope["SetStartSending"] = setStartSending;
webSerialScope["SetSendChunk"] = setSendChunk;
webSerialScope["SetFinishSending"] = setFinishSending;
webSerialScope["SetOnConnectionStateHasChanged"] = setOnConnectionStateHasChanged;

webSerialScope["Connect"] = connectToWebSerialAsync;
webSerialScope["Write"] = writeAsync;

webSerialScope["ResetCallbacks"] = resetCallbacks;
webSerialScope["Disconnect"] = disconnectWebSerial;

const startBlazorIfWebSerialIsSupported = async () => {
  if (checkBrowserIsSupported()) {
    console.log("Browser is supported");
    // blazor framework autostart is disabled, therefore we need to start it here
    window["Blazor"].start({});
  }
  else {
    console.error("Browser is not supported");
    setTimeout(() => window.document.write("Only Google Chrome and Microsoft Edge browsers are supported."), 100);
  }
}

startBlazorIfWebSerialIsSupported();